var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76367 4.34277C7.44701 3.65942 8.55489 3.65958 9.23828 4.34277H9.23926L11.3652 6.46875C11.6578 6.76155 11.6577 7.23646 11.3652 7.5293C11.0724 7.8221 10.5976 7.82194 10.3047 7.5293L8.75098 5.97559V14.165C8.75098 14.5793 8.41519 14.915 8.00098 14.915C7.58688 14.9149 7.25098 14.5792 7.25098 14.165V5.97656L5.69824 7.5293C5.40541 7.82213 4.9306 7.82201 4.6377 7.5293C4.3449 7.23639 4.34483 6.76161 4.6377 6.46875L6.76367 4.34277ZM12.835 1.08203C13.2489 1.08238 13.585 1.41803 13.585 1.83203C13.5849 2.24597 13.2488 2.58168 12.835 2.58203H3.16797C2.7538 2.58203 2.41804 2.24619 2.41797 1.83203C2.41797 1.41782 2.75376 1.08203 3.16797 1.08203H12.835Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.deac9d289a5a81d569aec2f54ae61e0e.svg";
export { ForwardRef as ReactComponent };